export default __webpack_public_path__ + "static/media/eye-open.20b512b8.svg";